// Vision, mission, the five pillars, and all 14 Culture Codes.

export const CULTURE = {
  verse:{
    text:"Those who are planted in the house of the LORD shall flourish in the courts of our God.",
    ref:"Psalm 92:13"
  },
  vision:"Engage the Culture. Live Out Loud.",
  mission:"We believe everyone has a unique purpose, and God wants to use your story to share His love.",
  missionBreakdown:[
    {
      h:"Everyone has a unique purpose",
      p:"No copy-paste callings. You're not an accident. You're not a mistake. You're handpicked by God with a purpose no one else can fulfill."
    },
    {
      h:"God wants to use your story",
      p:"Your pain. Your past. Your personality. All of it becomes prophecy when you surrender it to God."
    },
    {
      h:"To share His love",
      p:"That's the goal. Not just to know Him — to make Him known. Through your life. Your words. Your story."
    }
  ],
  pillars:[
    {
      icon:"🖤",
      name:"Love Leads",
      def:"Before strategy. Before excellence. Before being right. Love walks in the room first — it's how Jesus led, so it's how we lead. If love isn't leading, we're not following."
    },
    {
      icon:"🔊",
      name:"Give Out Loud",
      def:"Generosity isn't quiet in this house. Time, talent, treasure — given with joy, out loud, like God is trustworthy. Because He is."
    },
    {
      icon:"🌀",
      name:"There Is More",
      def:"More of God. More of His presence. More than we've seen. We never let the last move of God become the ceiling for the next one."
    },
    {
      icon:"🌎",
      name:"Engage the Culture",
      def:"We don't hide from the culture — we walk into it. Like Paul: adapt the approach, never the message, so more people meet Jesus."
    },
    {
      icon:"🔥",
      name:"Live Out Loud",
      def:"Faith was never meant to whisper. Your story, your praise, your purpose — public. History doesn't happen in private."
    }
  ],
  partnership:"We don't attend out of obligation. We show up out of revelation. We pray like heaven hears us, we serve like souls depend on it, and we give like God is trustworthy.",
  anchorRef:"1 Corinthians 9:19–23",
  anchorNote:"Paul adapted to the culture of every place he went so he could more easily win people to Christ. That's the blueprint: engage the culture — never compromise the message.",
  codes:[
    {
      n:1,
      name:"Leaders show up",
      subs:[
        "For CLLXTV events",
        "For your team",
        "To the assignment",
        "To be pastored"
      ],
      line:"Leadership here is not about being loud. It's about being faithful. Presence leads power."
    },
    {
      n:2,
      name:"Leaders welcome change and find value in creative solutions",
      subs:[

      ],
      line:"We don't settle for 'the way it's always been done.' New ways, timeless message."
    },
    {
      n:3,
      name:"Leaders find value in over-communicating",
      subs:[

      ],
      line:"Vision leaks when we stop repeating — and stop repeating accurately. Over-explain the why."
    },
    {
      n:4,
      name:"Leaders lead with confident humility",
      subs:[
        "Servant leadership"
      ],
      line:"Confident in Christ. Humble in service. True strength often looks like meeting people where they are."
    },
    {
      n:5,
      name:"Leaders believe the power of God is bigger",
      subs:[
        "Than our perspective",
        "Than our priorities",
        "Than our personality",
        "Than our pain points"
      ],
      line:"We don't flinch at hard things — we flex with faith."
    },
    {
      n:6,
      name:"Leaders passionately pursue personal discipleship",
      subs:[

      ],
      line:"Discipleship is helping people reach their God-given potential. It starts with your own."
    },
    {
      n:7,
      name:"Leaders pay continuous attention to excellence",
      subs:[

      ],
      line:"Excellence isn't perfection. It's continuous attention."
    },
    {
      n:8,
      name:"Leaders celebrate",
      subs:[

      ],
      line:"Wins get named out loud in this house. Heaven throws parties — so do we."
    },
    {
      n:9,
      name:"Leaders lead through the biblical principle of the tithe and giving",
      subs:[

      ],
      line:"We give like God is trustworthy. First, not leftover."
    },
    {
      n:10,
      name:"Leaders steward the atmosphere for collaboration",
      subs:[

      ],
      line:"The room belongs to everybody. Guard the atmosphere like it's your assignment — because it is."
    },
    {
      n:11,
      name:"Leaders actively pursue living the life of a New Testament believer",
      subs:[

      ],
      line:"Not church attendance. A lifestyle. Casual, connected, committed — keep moving right."
    },
    {
      n:12,
      name:"Leaders lead with kindness",
      subs:[

      ],
      line:"Kindness is not weakness. It's the culture's first impression."
    },
    {
      n:13,
      name:"Leaders honor discretion",
      subs:[

      ],
      line:"What's shared in trust stays in trust. Honor covers what gossip would expose."
    },
    {
      n:14,
      name:"Leaders count the cost",
      subs:[
        "Lift the burden",
        "Show up ready"
      ],
      line:"“Who would construct a house before first sitting down to estimate the cost?” (Luke 14:28 TPT)"
    }
  ]
};
